import { render, staticRenderFns } from "./reportDesc.vue?vue&type=template&id=6c49eede&scoped=true"
import script from "./reportDesc.vue?vue&type=script&lang=js"
export * from "./reportDesc.vue?vue&type=script&lang=js"
import style0 from "./reportDesc.vue?vue&type=style&index=0&id=6c49eede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49eede",
  null
  
)

export default component.exports